import axios from '../http';
import { HttpResponse } from '@/types/HttpResponse';
import { FlightInBuy, FlightAll, FlightAllId } from '@/types/Flight';

//封装接口方法
export class FlightService {
  /**
   * @description 查询航班相关信息
   *
   * @return {HttpResponse} result
   */
  static async selectFlight(data: FlightInBuy): Promise<HttpResponse> {
    return axios('/selectFlights', {
      method: 'post',
      responseType: 'json',
      data: data,
    });
  }
  static async selectFlightsInList(data: {
    airportName: string;
    op: string;
  }): Promise<HttpResponse> {
    return axios('/selectFlightsInList', {
      method: 'post',
      responseType: 'json',
      data: data,
    });
  }
  static async selectSpecificFlightByDate(data: {
    flightId: string;
    departureDate: Date;
  }): Promise<HttpResponse> {
    return axios('/selectSpecificFlightByDate', {
      method: 'post',
      responseType: 'json',
      data: data,
    });
  }

  static async findFlightExit(params: {
    flightID: string;
  }): Promise<HttpResponse> {
    return axios('/getFlight', {
      method: 'post',
      responseType: 'json',
      params: params,
    });
  }

  static async registerFlight(data: FlightAll): Promise<HttpResponse> {
    return axios('/registerFlight', {
      method: 'post',
      responseType: 'json',
      data: data,
    });
  }

  static async updateFlight(data: {
    data: FlightAllId;
  }): Promise<HttpResponse> {
    return axios('/updateFlight', {
      method: 'post',
      responseType: 'json',
      data: data,
    });
  }

  static async getAllFlightId(): Promise<HttpResponse> {
    return axios('/getAllFlightId', {
      method: 'get',
      responseType: 'json',
    });
  }

  static async getAllFlights(): Promise<HttpResponse> {
    return axios('/getAllFlights', {
      method: 'get',
      responseType: 'json',
    });
  }

  static async deleteSpecificFlightById(data: {
    id: Number;
  }): Promise<HttpResponse> {
    return axios('/deleteSpecificFlightById', {
      method: 'post',
      responseType: 'json',
      data: data,
    });
  }

  static async selectAllAirport(): Promise<HttpResponse> {
    return axios('/selectAllAirport', {
      method: 'get',
      responseType: 'json',
    });
  }
}
